import React, { useMemo } from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import TableHead from './Head';
import TableBody from './Body';

import useShiftSelected from '../../../../utils/hooks/useShiftSelected';

const UpdatesTable = ({ items, access, filters, setConfirmValues, toggleConfirm, values, setValues }) => {
  const itemsIds = useMemo(() => items?.map((i) => i.id), [items]);

  const onChange = useShiftSelected(itemsIds, values);

  const onChangeCheck = (event, update) => {
    const nextValue = onChange(event, update.id);

    setValues(nextValue);
  };

  const onChangeCheckAll = (e) => {
    if (e.target.value === 'checkAll' && e.target.checked) {
      return setValues([...items.map((item) => item.id)]);
    }
    if (e.target.value === 'checkAll' && !e.target.checked) {
      return setValues([]);
    }
  };

  const handleSelectMass = (key) => {
    if (key === 1) {
      setConfirmValues({ id: null, title: 'mass' });
      toggleConfirm();
    }
  };

  return (
    <Table className="updates-table table-grey">
      <TableHead
        access={access}
        filters={filters}
        toggleConfirm={toggleConfirm}
        values={values}
        onChangeCheck={onChangeCheckAll}
        handleSelectMass={handleSelectMass}
      />
      <TableBody
        items={items}
        access={access}
        setConfirmValues={setConfirmValues}
        toggleConfirm={toggleConfirm}
        values={values}
        onChangeCheck={onChangeCheck}
      />
    </Table>
  );
};

UpdatesTable.propTypes = {
  items: PropTypes.array,
  access: PropTypes.object,
  filters: PropTypes.array,
  setConfirmValues: PropTypes.func,
  toggleConfirm: PropTypes.func,
  values: PropTypes.array,
  setValues: PropTypes.func,
};

export default UpdatesTable;
